<template>
  <system-frame title="Lekkinud paroolid" section="Turvalisus" hint="Intra kasutajate paroolid avalike lekkinud paroolide nimekirjade vastu (Have I Been Pwned).">
    <!-- server/controllers/pwned.js; the check itself is service/pwned.js. -->
    <v-alert v-if="error" type="error" variant="tonal" class="mb-4">{{ error }}</v-alert>

    <card class="mb-6">
      <div class="d-flex align-start ga-4">
        <div class="flex-grow-1">
          <div class="text-h6">Kontrolli paroole</div>
          <p class="text-body-2 text-grey-darken-2 mb-0">
            Parooliga sisselogimisel ja parooli vahetamisel. Serverist läheb välja ainult parooli räsi 5 esimest märki,
            parooli ennast ega räsi ei saadeta ega salvestata. Kui teenus ei vasta, lastakse sisse nagu tavaliselt.
          </p>
        </div>
        <v-switch
          :model-value="on"
          aria-label="Kontrolli paroole"
          color="green"
          inset
          hide-details
          :disabled="saving || !loaded"
          @update:model-value="save($event)"
        />
      </div>
      <p class="text-body-2 text-grey-darken-2 mt-3 mb-0">
        <template v-if="!on">Väljas: paroole ei kontrollita ja keegi ei näe meeldetuletust.</template>
        <template v-else>
          Sees: lekkinud parooliga kasutaja näeb pärast sisselogimist meeldetuletust (kord sessiooni kohta), kuni parooli vahetab.
          Lekkinud parooli ei saa enam uueks parooliks panna, ka admin Kasutajate lehel mitte.
        </template>
      </p>
      <p v-if="counts" class="text-body-2 text-grey-darken-2 mt-2 mb-0">
        Kontrollitud {{ counts.checked }} aktiivset kasutajat {{ counts.total }}-st. Ülejäänud kontrollitakse nende järgmisel parooliga sisselogimisel.
      </p>
    </card>

    <card>
      <div class="text-h6 mb-2">Lekkinud parooliga kasutajad</div>
      <p v-if="loaded && !leaked.length" class="text-body-2 text-grey-darken-2 mb-0">Praegu pole kellelgi teadaolevalt lekkinud parooli.</p>
      <div v-else-if="leaked.length" class="pw-scroll">
        <table class="pw-table">
          <thead>
            <tr>
              <th scope="col">Kasutaja</th>
              <th scope="col" class="num">Lekkeid</th>
              <th scope="col">Kontrollitud</th>
              <th scope="col">Viimati sees</th>
              <th scope="col">Pääsuvõti</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in leaked" :key="row.id">
              <td>
                <router-link :to="'/users/' + row.id">{{ row.firstName }} {{ row.lastName }}</router-link>
                <small>{{ row.email }}</small>
              </td>
              <td class="num">{{ row.count.toLocaleString('et-EE') }}</td>
              <td>{{ day(row.checkedAt) }}</td>
              <td>{{ day(row.lastLogin) }}</td>
              <td>{{ row.hasPasskey ? 'Jah' : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-body-2 text-grey-darken-2 mt-3 mb-0">
        Kasutaja kaob nimekirjast, kui ta parooli vahetab (Minu seaded → Muuda parooli) või admin talle uue parooli paneb.
      </p>
    </card>
  </system-frame>
</template>

<script>
import api from '@/api'
import SystemFrame from '@/components/SystemFrame.vue'

export default {
  components: { SystemFrame },
  data () {
    return { on: false, counts: null, leaked: [], loaded: false, saving: false, error: '' }
  },
  async mounted () {
    try {
      this.apply(await api.getPwnedPasswords())
    } catch (err) {
      this.error = err.message
    }
  },
  methods: {
    apply (data) {
      this.on = data.on
      this.counts = data.counts
      this.leaked = data.leaked
      this.loaded = true
    },
    day (value) {
      if (!value) return '—'
      const d = new Date(value)
      return d.toLocaleDateString('et-EE', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
    async save (on) {
      this.saving = true
      this.error = ''
      try {
        this.apply(await api.savePwnedPasswords(on))
      } catch (err) {
        this.error = err.message
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.pw-scroll { overflow-x: auto; }
.pw-table { width: 100%; border-collapse: collapse; font-size: 14px; }
.pw-table th { text-align: left; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #5B6B66; padding: 6px 10px; border-bottom: 1px solid #C9D2CE; white-space: nowrap; }
.pw-table td { padding: 8px 10px; border-bottom: 1px solid #E1E7E4; vertical-align: top; }
.pw-table td small { display: block; color: #5B6B66; font-size: 12.5px; }
.pw-table .num { text-align: right; font-variant-numeric: tabular-nums; }
</style>
